// extracted by mini-css-extract-plugin
export var root = "hnjWtddMJpF5fBbp1W_Q";